import { render, staticRenderFns } from "./ViewDns.vue?vue&type=template&id=1603aff5&"
import script from "./ViewDns.vue?vue&type=script&lang=ts&"
export * from "./ViewDns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports